import { SettingOutlined } from "@ant-design/icons"

const ExtraMenu = [
  {
    title: "Settings",
    Link: "/settings",
    icon: <SettingOutlined />,
    access: [{ label: "View", value: "settings" }],
  },
]

export default ExtraMenu
